export default "__VITE_ASSET__BtOx$4os__"